<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'Workspace'})"/>
                {{ $t('health.patient.title') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="patientTable"
              :data="fetchData"
              sort-by="name"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                label=""
                header-class="text-left"
                cell-class="table-component__text-left">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.viber_plus"
                    class="rotated-90 red zoom"
                    :icon="icon.viberPlusLogo"
                  />
                  <font-awesome-icon
                    v-else-if="row.viber"
                    class="rotated-90 red zoom"
                    :icon="icon.viberLogo"
                  />
                </template>
              </table-column>
              <table-column
                label=""
                header-class="text-left"
                cell-class="table-component__text-left">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="isBirthday(row.birthday)"
                    class="red"
                    :icon="icon.birthday"
                  />
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="displayUserDataModal(row)"
                    :icon="icon.info"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
              <table-column
                show="id"
                :hidden="true"
                :filterable="false"
                data-type="boolean">
              </table-column>
              <table-column
                show="username"
                :label="$t('health.patient.username')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>
              <table-column
                show="name"
                :label="$t('health.patient.name')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>
              <table-column
                show="surnames"
                :label="$t('health.patient.surname')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>
              <table-column
                show="email"
                :label="$t('health.patient.email')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                show="weekly_trainings"
                :label="$t('health.patient.weeklyTrainings')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                show="average_training_time"
                :label="$t('health.patient.averageTrainingTime')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                show="calories_need"
                :label="$t('health.patient.caloricNeeds')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

            </table-component>
          </grid-col>
        </grid-row>
      </div>
      <patient-data-modal
        v-if="showUserModal"
        :user="selectedUser"
        v-on:close="closeUserModal"
      />
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Chevron from '@/components/shared/Chevron';
import PatientDataModal from 'BRAND/components/patients/PatientDataModal';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import patientApi from 'BRAND/api/patient';
import {faHexagon, faPlusHexagon, faBirthdayCake, faInfoCircle} from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'PatientList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    Chevron,
    PatientDataModal
  },
  data () {
    return {
      patients: [],
      selectedUser: null,
      showUserModal: false,
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      },
      icon: {
        viberLogo: faHexagon,
        viberPlusLogo: faPlusHexagon,
        birthday: faBirthdayCake,
        info: faInfoCircle
      },
      breadcrumb: [
        {link: '/workspace', nameKey: 'menu.workspace'},
        {link: '/myPatient', nameKey: 'health.patient.title', disabled: true}
      ]
    };
  },
  mounted () {
    this.requestData();
  },
  watch: {
    getPatients: {
      handler: function () {
        this.$refs.patientTable.refresh();
      }
    }
  },
  computed: {
    getBreadcrumb () {
      return this.breadcrumb.map(route => {
        route.name = this.$t(route.nameKey);
        return route;
      });
    },
    getPatients () {
      return this.patients;
    }
  },
  methods: {
    requestData () {
      patientApi.getMyPatients(this).then((data) => {
        this.patients = data;
      });
    },
    isBirthday (birthday) {
      if (birthday == null) {
        return false;
      }
      const date = new Date(birthday);
      if (date.getDate() === new Date().getDate() && date.getMonth() === new Date().getMonth()) {
        return true;
      }
      return false;
    },
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.getPatients,
        this.tableState,
        ['username', 'name', 'surname', 'email'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    displayUserDataModal (user) {
      this.selectedUser = user;
      this.showUserModal = true;
    },
    closeUserModal () {
      this.selectedUser = null;
      this.showUserModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.red {
  color: $primary;
}
.rotated-90 {
  transform: rotate(90deg);
}

.zoom:hover {
  transform: rotate(360deg);
  transition: 2s ease-out;
}

</style>




// WEBPACK FOOTER //
// src/brand/health/layouts/patient/PatientListNutri.vue